import React from 'react'
import StatusErrorContainer from 'src/containers/Error/StatusError'

const StatusErrorPage: React.FC = () => {
  return <StatusErrorContainer />
}

export const PATH = '/status-error' as const
export default StatusErrorPage
